module.exports = __webpack_public_path__ + "static/media/galleries.e08ef212.jpg";